module.exports = __webpack_public_path__ + "static/media/momentum-logo.a3f0fb1a.png";